import React, { useState, useRef } from "react";
import axios from "axios";
import { Clock, ArrowRight, Rocket, ChevronLeft, ChevronRight } from "lucide-react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./HeroSectionFinal.css";
import { generateApiKey } from "../../../helpers/common.helpers";
import FeedbackForm from "./Navbar/FeedbackForm"; // Import your FeedbackForm component
import { updateUserFeedbackCountServices } from "../../../services/users.services";
import { useMutation } from "@tanstack/react-query";

const freeCourses = [
  {
    id: "pm",
    badgeLabel: "NEW SELF-PACED COURSE",
    partnerPill: null,
    partnerAlt: null,
    title: "Transform Ideas into Impact with Product Management",
    description:
      "Learn how to understand customers, define problems, build product strategy, prioritize, experiment, launch, and measure successful products.",
    meta: "Self-Paced • 6 Modules • Certificate on Completion",
    ctaText: "Start Learning for Free",
    slug: "transform-ideas-into-impact-with-product-management",
    imageUrl:
      "https://storage.googleapis.com/accredian-assets/Frontend_Assests/Images/Accredian-react-site-images/logo/accredian%20dashbaord%20imge.webp",
    imageAlt: "Transform Ideas into Impact with Product Management",
    imagePosition: "object-cover object-center",
  },
  {
    id: "genai",
    badgeLabel: "Just Launched",
    partnerPill:
      "https://2da746d2-8b54-4a73-a2f3-7868ed65f7bf.lovableproject.com/__l5e/assets-v1/e946728a-645f-496e-99ac-463c12a90edd/ms-partner-pill.png",
    partnerAlt: "Microsoft Official Training Partner",
    title: "Transform Business Workflows with Generative AI",
    description: "Work smarter with Microsoft Official training on Generative AI.",
    meta: null,
    ctaText: "Start Learning for Free",
    slug: "transform-business-workflows-with-generative-ai",
    imageUrl:
      "https://2da746d2-8b54-4a73-a2f3-7868ed65f7bf.lovableproject.com/__l5e/assets-v1/a0a085bd-314b-4ff4-8ee8-18990bd52570/banner-hero.png",
    imageAlt: "Professional using Microsoft 365 Copilot",
    imagePosition: "object-cover object-center",
  },
];

const Button = ({ children, className = "", style, ...props }) => {
  return (
    <button
      className={`inline-flex items-center justify-center transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 ${className}`}
      style={style}
      {...props}
    >
      {children}
    </button>
  );
};

const HeroSectionFinal = () => {
  const [loading, setLoading] = useState(false);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [shouldCallApiAfterFeedback, setShouldCallApiAfterFeedback] = useState(false);
  const isLocked = localStorage.getItem("status") !== "active";
  const sliderRef = useRef(null);

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 7000,
    pauseOnHover: true,
    arrows: false,
    swipe: true,
    draggable: true,
  };

  const fetchthinficurl = async () => {
    setLoading(true);
    try {
      const response = await axios({
        method: "post",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "page-index": generateApiKey(),
        },
        url: `${process.env.REACT_APP_API_ENDPOINT_NODE_PRODUCTION_DASHBOARD}/dashboardhomepage/fetch_thinkific_url`,
        data: {
          email: localStorage.getItem("email"),
          firstname: localStorage.getItem("username"),
          lastname: localStorage.getItem("lastname"),
        },
      });
      setLoading(false);
      const url = response.data;
      window.open(url, "_blank"); // Open in new tab or replace with window.location.href = url to redirect same tab
    } catch (error) {
      setLoading(false);
      console.error("Error fetching Thinkific URL:", error);
    }
  };

  const { mutate: updateUserFeedBackCount } = useMutation({
    mutationFn: ({ userId }) =>
      updateUserFeedbackCountServices({ userId }),
    onSuccess: (data) => {
      // queryClient.invalidateQueries(["acknowledgment-status"]);
      // setOpen(false);
      console.log(data)
      localStorage.setItem("feedback_count", data.feedback_count);
    },
    onError: (error) => {
      console.error("Error updating acknowledgment status:", error);
    }
  });


  const checkEmailInGoogleSheets = async () => {
    try {
      // const feedbackCount = localStorage.getItem("dashboardFeedBackCount") || 0
      const backendFeedbackCount = Number(localStorage.getItem("feedback_count")) || 0
      const dashboardFeedBackCount = Number(localStorage.getItem("dashboardFeedBackCount")) || 0;
      const dashboardFeedbackStatus = Number(localStorage.getItem("dashboardFeedbackStatus")) || 0;
      // const userEmail = localStorage.getItem("email");
      // updateUserFeedBackCount({ userId: localStorage.getItem("user_id") });
      // const res = await fetch(
      //   "https://script.google.com/macros/s/AKfycbw101VUPZ28IEdK-X6fZFLukOn4Lrkp5Av0Zus5aiVurzgFBqvunskYNQBQhfOWhs2P/exec"
      // );
      // const data = await res.json();
      // const emailRecord = data.emailData.find(item => item.email === userEmail);


      if (dashboardFeedbackStatus === 1) {
        return true
      } else if (dashboardFeedBackCount > 1) {
        return true
      } else if (backendFeedbackCount >= 3) {
        return true
      } else {
        return false
      }


      // if (feedbackCount > 3 || backendFeedbackCount > 3) {
      //   return true
      // } else ifelse if (feedbackCount <= 3) {

      //   if (emailRecord) {
      //     return true;
      //   } else {

      //     return false;
      //   }
      // } else {
      //   return true
      // }

    } catch (error) {
      console.error("Error checking email in Google Sheets:", error);
      // If there's an error checking, assume email doesn't exist and show feedback
      return false;
    }

  };

  const handleContinueLearning = async () => {

    const dashboardFeedBackCount = localStorage.getItem("dashboardFeedBackCount") || 0;
    localStorage.setItem("dashboardFeedBackCount", Number(dashboardFeedBackCount) == 0 ? 1 : Number(dashboardFeedBackCount) + 1);
    // Check if email exists in Google Sheets
    setLoading(true)
    const emailExists = await checkEmailInGoogleSheets();
    setLoading(false)
    if (emailExists) {
      // Email exists, directly call the API
      await fetchthinficurl();
    } else {
      // Email doesn't exist, show feedback modal first
      // const feedbackCount = localStorage.getItem("dashboardFeedBackCount") || 0
      // console.log(feedbackCount)
      // if (feedbackCount > 3) {
      //   await fetchthinficurl()
      //   setShowFeedbackModal(false);
      // } else {
      // localStorage.setItem("dashboardFeedBackCount", Number(feedbackCount) + 1)
      updateUserFeedBackCount({ userId: localStorage.getItem("user_id") });
      setShouldCallApiAfterFeedback(true)
      setShowFeedbackModal(true);
      // }
      // setShowFeedbackModal(true);
    }
  };

  const handleFeedbackClose = async () => {
    setShowFeedbackModal(false);

    // If we need to call the API after feedback, do it now
    if (shouldCallApiAfterFeedback) {
      setShouldCallApiAfterFeedback(false);
      await fetchthinficurl();
    }
  };

  return (
    <>
      {!isLocked && (
        <section
          role="region"
          aria-label="New self-paced course announcement"
          className="relative hero-slider-container mb-6 group"
        >
          <Slider ref={sliderRef} {...sliderSettings}>
            {freeCourses.map((course) => (
              <div key={course.id} className="outline-none h-full flex flex-col">
                <div className="relative overflow-hidden rounded-2xl border border-announce-border bg-ann-card shadow-announce w-full sm:h-[280px]">
                  <div className="grid grid-cols-1 items-start sm:grid-cols-[minmax(0,1fr)_minmax(0,46%)] h-full w-full">
                    <div className="flex flex-col justify-center h-full gap-2 py-4 pl-6 pr-6 sm:py-5 sm:pl-14 sm:pr-7">
                      <div className="flex items-center gap-3 sm:gap-4 flex-nowrap min-h-[28px] sm:min-h-[32px]">
                        <div className="flex items-center gap-2 -translate-y-[2px] sm:-translate-y-[3px] shrink-0">
                          <span className="relative flex h-2 w-2">
                            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-green-500 opacity-70"></span>
                            <span className="relative inline-flex h-2 w-2 rounded-full bg-green-500"></span>
                          </span>
                          <span className="text-xs font-semibold uppercase tracking-wide text-announce-badge-fg leading-none">
                            {course.badgeLabel}
                          </span>
                        </div>
                        {course.partnerPill && (
                          <div className="flex items-center shrink-0">
                            <img
                              src={course.partnerPill}
                              alt={course.partnerAlt || "Partner"}
                              className="h-10 w-auto sm:h-12  object-contain block m-0 align-middle"
                            />
                          </div>
                        )}
                      </div>

                      <h2 className="text-2xl font-bold leading-tight tracking-tight text-announce-heading sm:text-[26px]">
                        {course.title}
                      </h2>

                      <p className="text-sm text-announce-body sm:text-[15px]">
                        {course.description}
                      </p>

                      {course.meta && (
                        <p className="text-xs font-semibold text-announce-badge-fg">
                          {course.meta}
                        </p>
                      )}

                      <div className="pt-1">
                        <a
                          href={`${process.env.REACT_APP_ACCREDIAN_SITE_URL || "https://accredian.com"}/free-courses/${course.slug}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="group flex sm:inline-flex items-center justify-center gap-2 w-full sm:w-fit rounded-lg bg-announce-cta px-5 py-2.5 text-sm font-semibold text-announce-cta-foreground shadow-announce-cta transition hover:bg-announce-cta-hover"
                        >
                          {course.ctaText}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <line x1="5" y1="12" x2="19" y2="12" />
                            <polyline points="12 5 19 12 12 19" />
                          </svg>
                        </a>
                      </div>
                    </div>

                    <div className="relative hidden overflow-hidden bg-ann-card sm:block h-full w-full">
                      <img
                        src={course.imageUrl}
                        alt={course.imageAlt}
                        className={`h-full w-full ${course.imagePosition || "object-cover object-center"}`}
                        loading="lazy"
                      />
                      <div
                        aria-hidden="true"
                        className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-ann-card to-transparent"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>

          <button
            type="button"
            onClick={() => sliderRef.current?.slickPrev()}
            aria-label="Previous course"
            className="absolute left-2 top-1/2 -translate-y-1/2 z-20 hidden sm:flex h-8 w-8 items-center justify-center rounded-full bg-white/90 text-gray-700 shadow-md border border-gray-200 transition-all hover:bg-white hover:scale-105"
          >
            <ChevronLeft className="h-4 w-4" />
          </button>
          <button
            type="button"
            onClick={() => sliderRef.current?.slickNext()}
            aria-label="Next course"
            className="absolute right-2 top-1/2 -translate-y-1/2 z-20 hidden sm:flex h-8 w-8 items-center justify-center rounded-full bg-white/90 text-gray-700 shadow-md border border-gray-200 transition-all hover:bg-white hover:scale-105"
          >
            <ChevronRight className="h-4 w-4" />
          </button>
        </section>
      )}

      <div
        className="min-w-0 overflow-hidden rounded-xl border border-gray-200 mb-8"
        style={{
          background:
            "linear-gradient(135deg, #1E40AF 0%, #2563EB 50%, #3B82F6 100%)",
          borderRadius: "12px",
          padding: "30px 20px",
          boxShadow: "0 10px 30px rgba(30,64,175,0.2)",
        }}
      >
        <div className="relative z-10 flex flex-col md:flex-row items-center justify-between">
          <div className="flex-1  text-center md:text-left pr-0 mb-6 md:pr-8">
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold text-white mb-2 md:mb-6">
              Welcome back, {localStorage.getItem("username")}!
            </h1>
            <p className="text-sm md:text-xl text-blue-100">
              Everything you need to move forward is <span className=" italic ">right here</span>.
            </p>
          </div>
          <div className="flex flex-col gap-4  items-center">
            <Button
              onClick={() => {
                const element = document.getElementById("cod");
                element?.scrollIntoView({ behavior: "smooth" });
              }}
              className={`h-12 ${!isLocked ? "w-full" : "w-[300px]"} px-6  rounded-full font-bold transition-all duration-300 hover:scale-105 group relative overflow-hidden`}
              style={{
                background: "rgba(255,255,255,0.1)",
                color: "white",
                border: "1px solid rgba(255,255,255,0.2)",
                backdropFilter: "blur(10px)",
              }}
            >
              <div className="absolute inset-0 bg-white/10 translate-x-[-100%] group-hover:translate-x-0 transition-transform duration-500" />
              <Clock className="w-4 h-4 mr-2 relative z-10" />
              <span className="relative z-10 text-[16px]">Challenge of the Day</span>
            </Button>
            {!isLocked ? (
              <Button
                id="tour-continue-learning"
                onClick={handleContinueLearning}
                disabled={loading}
                className="h-12 w-full px-10 font-bold text-[16px] transition-all duration-500 group relative overflow-hidden floating-card rounded-full"
                style={{
                  background: "linear-gradient(135deg, #FFFFFF 0%, #F1F5F9 100%)",
                  color: "#1E40AF",
                  transformStyle: "preserve-3d",
                  perspective: "1000px",
                }}
              >
                <div
                  className="absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-all duration-500 transform translate-y-2 translate-x-2"
                  style={{
                    background:
                      "linear-gradient(135deg, rgba(30,64,175,0.2) 0%, rgba(59,130,246,0.1) 100%)",
                    filter: "blur(12px)",
                    zIndex: -1,
                  }}
                />
                <div className="absolute opacity-0 group-hover:opacity-100 transition-all duration-300">
                  <div className="rocket-trail trail-1"></div>
                  <div className="rocket-trail trail-2"></div>
                  <div className="rocket-trail trail-3"></div>
                </div>
                <div className="absolute inset-0 overflow-hidden rounded-full">
                  <div className="orbital-particle particle-1"></div>
                  <div className="orbital-particle particle-2"></div>
                  <div className="orbital-particle particle-3"></div>
                  <div className="orbital-particle particle-4"></div>
                </div>


                <div className="relative z-10 flex items-center">
                  <Rocket className="w-6 h-6 mr-4 transition-all duration-300 rocket-launch" />
                  <span className="tracking-wide transition-all duration-300 group-hover:text-blue-700">
                    {loading ? "Please wait while we load your course" : "Continue Learning"}
                  </span>
                  {/* <ArrowRight className="w-6 h-6 ml-4 transition-all duration-500 group-hover:translate-x-3 group-hover:scale-110" /> */}
                </div>
              </Button>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>

      {/* Feedback Modal */}
      {showFeedbackModal && (
        <FeedbackForm onClose={handleFeedbackClose} />
      )}
    </>
  );
};

export default HeroSectionFinal;
